import { NavigateFunction } from 'react-router-dom';
import { PagesPaths } from '@/enums';

let navigate: NavigateFunction;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const redirectToLogin = () => {
  const url = new URL(window.location.href);
  const currentPathname = url.pathname;

  if (currentPathname === '/') {
    return;
  }

  if (navigate) {
    navigate(PagesPaths.Login);
  }
};
